import { AjaxService } from "../Helpers/AjaxService"
import { GrowerSegmentData } from "../Models/Segment/GrowerSegmentData";


export class SegmentApi {
    private static instance: SegmentApi;
    static getInstance() { return SegmentApi.instance || (SegmentApi.instance = new SegmentApi()); }

    getSegmentData() {
        const ajaxService = AjaxService.getInstance();
        const apiUrl = `/api/segment/GetSegmentData`;

        return new Promise<GrowerSegmentData>((resolve) => {
            ajaxService.get(apiUrl, (result: GrowerSegmentData) => resolve(result));
        }); 


    }

}